import Card from '$tablet-app/src/app/components/Card';
import Text from '$tablet-app/src/app/components/Text';
import { getGoalFrequencyDisplayText } from '$tablet-app/src/app/goals/functions';
import { palette } from '$tablet-app/src/app/theme';
import { Goal } from '@akin-home/goals';
import React, { FC } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
// import styled from "styled-components/native"

interface Props {
  style?: StyleProp<ViewStyle>;
  goal: Goal;
  onPress?: (goal: Goal) => void;
}

const GoalLibraryCard: FC<Props> = (props) => {
  const { goal, onPress, style } = props;
  const handleOnPress = () => onPress?.(goal);

  return (
    <StyledCard style={style}>
      <TouchableContainer onPress={handleOnPress}>
        <EmojiBorder>
          <EmojiContainer>
            <Emoji>{goal.emoji || '🎯'}</Emoji>
          </EmojiContainer>
        </EmojiBorder>

        <TextContainer>
          <TitleText weight="semibold" numberOfLines={2}>
            {goal.title}
          </TitleText>
          <GoalFrequencyText variant="p2">
            {getGoalFrequencyDisplayText(goal)}
          </GoalFrequencyText>
        </TextContainer>
      </TouchableContainer>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  padding: 16px;
`;

const TouchableContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const EmojiBorder = styled.View`
  border: 4px solid ${palette.lightGrey};
  background-color: white;
  padding: 6px;
  border-radius: 120px;
  height: 60px;
  width: 60px;
`;

const EmojiContainer = styled.View`
  background-color: rgba(83, 90, 241, 0.1);
  border-radius: 120px;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const Emoji = styled.Text`
  font-size: 16px;
`;

const TextContainer = styled.View`
  gap: 2px;
  max-width: 100%;
`;

const TitleText = styled(Text)`
  overflow: hidden;
  width: 100%;
  max-height: 50%;
`;

const GoalFrequencyText = styled(Text)`
  width: 100%;
  max-height: 50%;
`;

export default GoalLibraryCard;
